module.exports = __webpack_public_path__ + "img/Mobilewebsitelayouttest.50b47c5b.jpg";